import { ChangeEvent } from 'react';
import { Div, Flex, Gutter, RadioButton, OptionListOption, Title } from '@gaiads/telia-react-component-library';
import { TeliaButton, TeliaForm, TeliaTextInput } from '@teliads/components/react';
import { useTranslation } from 'react-i18next';

import { Errors } from '../utils';

import styles from './RegionSelection.module.scss';

interface RegionSelectionProps {
  loadingPim: boolean;
  regions: OptionListOption[];
  initialRegionSelected: string;
  setInitialRegionSelected: (region: string) => void;
  initialBusinessId: string | undefined;
  setInitialBusinessId: (businessId: string) => void;
  customerBusinessIdForNorwayError: string | undefined;
  handleNextInRegionSelectionPhase: () => void;
  setCustomerOrgValidationErrors: (error: Errors | undefined) => void;
}

export default function RegionSelection(props: RegionSelectionProps) {
  const {
    loadingPim,
    regions,
    initialRegionSelected,
    setInitialRegionSelected,
    initialBusinessId,
    setInitialBusinessId,
    customerBusinessIdForNorwayError,
    handleNextInRegionSelectionPhase,
    setCustomerOrgValidationErrors,
  } = props;
  const { t } = useTranslation('organizationForm');

  return (
    <>
      <TeliaForm
        name="region-selection"
        onSubmit={e => {
          e.preventDefault();
          handleNextInRegionSelectionPhase();
        }}
      >
        <Div padding={{ size: 'lg' }} boxShadow="md">
          <Title size={'sm'}>{t('regionSelection.title')}</Title>
          <Gutter size="layout-5" />
          <Flex>
            {regions.map(region => (
              <RadioButton
                key={region.value}
                value={region.value}
                checked={initialRegionSelected === region.value}
                label={region.label}
                onChange={() => {
                  setCustomerOrgValidationErrors(undefined);
                  setInitialRegionSelected(region.value);
                }}
                padding={{ right: 'md' }}
              />
            ))}
          </Flex>
          <Gutter size="layout-5" />
          <Div className={styles['customer-organization-form__region-selection__input']}>
            <TeliaTextInput
              label={t('regionSelection.businessIdInputLabel')}
              onInput={(e: ChangeEvent<HTMLTeliaTextInputElement>) => {
                setCustomerOrgValidationErrors(undefined);
                setInitialBusinessId(e.target.value);
              }}
              value={initialBusinessId}
              required={true}
              errorMessage={customerBusinessIdForNorwayError}
              requiredErrorMessage={t('regionSelection.businessIdInputRequiredError')}
            />
          </Div>
        </Div>
        <Gutter size="layout-5" />
        <Flex>
          <TeliaButton variant="primary" type="submit" disabled={loadingPim || !initialBusinessId || !initialRegionSelected}>
            {t('nextButton')}
          </TeliaButton>
        </Flex>
      </TeliaForm>
      <Gutter size="layout-5" />
    </>
  );
}
